import { SET_APP_CONFIG } from './app-config-actions';
export function appConfigReducer(state = {}, action) {
    switch (action.type) {
        case SET_APP_CONFIG:
            return action.payload;
        default:
            return state;
    }
}
//# sourceMappingURL=app-config-reducer.js.map